import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpService } from './http.service';
import { CoachService } from './coach.service';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  COACHTOKEN_KEY: string = 'calplay-coach-token';
  COACHTOKEN_USER: string = 'calplay-coach-user';
  SCHOOLTOKEN_KEY: string = 'calplay-school-token';
  SCHOOLTOKEN_USER: string = 'calplay-school-user';

  constructor(private httpService: HttpService, private router: Router,private coachService: CoachService) {}

  /**
   * ====================================================
   * Coach Authentication Methods
   *
   * Token Name - calplay-coach-token
   * User Details - calplay-coach-user
   * ====================================================
   * */

  coachLogin(payload: any) {
    return this.httpService.post('coach/login', payload);
  }

  coachSuccessLogin(data: any, rememberme: any = false) {
    if (rememberme === true) {
      localStorage.setItem(this.COACHTOKEN_KEY, data.token);
      localStorage.setItem(this.COACHTOKEN_USER, JSON.stringify(data.coach));
    } else {
      sessionStorage.setItem(this.COACHTOKEN_KEY, data.token);
      sessionStorage.setItem(this.COACHTOKEN_USER, JSON.stringify(data.coach));
    }
    //this.router.navigate(["/dashboard"]);
    if (data.is_subscribe == 'yes') {
      if(data.coach.user_type=='athletic_director')
      {
        this.router.navigate(['/athletic-director/dashboard']);

      }
      else{
        this.router.navigate(['/dashboard']);
      }

    } else {

      this.router.navigate(['/settings'], {
        queryParams: { tab: 'subscription' },
      });
    }
  }

  coachLogout() {
    localStorage.removeItem(this.COACHTOKEN_KEY);
    localStorage.removeItem(this.COACHTOKEN_USER);
    localStorage.removeItem('sport_level');
    localStorage.removeItem('selected_coach');

    localStorage.clear();

    sessionStorage.removeItem(this.COACHTOKEN_KEY);
    sessionStorage.removeItem(this.COACHTOKEN_USER);
    this.coachService.SetSportLevelName();
    this.coachService.SetSportLevel(null);
    this.coachService.setCoach(null);


    this.router.navigate(['/login'], { queryParams: { tab: 'coach' } });
  }
  clearALLStorage()
  {
localStorage.removeItem(this.COACHTOKEN_KEY);
    localStorage.removeItem(this.COACHTOKEN_USER);
    localStorage.removeItem('sport_level');
    localStorage.removeItem('selected_coach');
    localStorage.clear();
    sessionStorage.removeItem(this.COACHTOKEN_KEY);
    sessionStorage.removeItem(this.COACHTOKEN_USER);
    this.coachService.SetSportLevelName();
    this.coachService.SetSportLevel(null);
    this.coachService.setCoach(null);
  }

  coachLoggedIn() {
    return !!this.getCoachToken();
  }

  getCoachToken() {
    let token = localStorage.getItem(this.COACHTOKEN_KEY);
    if (!token) {
      token = sessionStorage.getItem(this.COACHTOKEN_KEY);
    }

    return token;
  }
  updateCoachSession(coach: any) {
    let userdetails = localStorage.getItem(this.COACHTOKEN_USER);
    if (!userdetails) {
      sessionStorage.setItem(this.COACHTOKEN_USER, JSON.stringify(coach));
    } else {
      localStorage.setItem(this.COACHTOKEN_USER, JSON.stringify(coach));
    }
  }
  updateSchoolSession(school: any) {
    let schooldetails = localStorage.getItem(this.SCHOOLTOKEN_USER);
    if (!schooldetails) {
      sessionStorage.setItem(this.SCHOOLTOKEN_USER, JSON.stringify(school));
    } else {
      localStorage.setItem(this.SCHOOLTOKEN_USER, JSON.stringify(school));
    }
  }
  getCoachSessionDetails() {
    let userdetails = localStorage.getItem(this.COACHTOKEN_USER);
    if (!userdetails) {
      userdetails = sessionStorage.getItem(this.COACHTOKEN_USER);
    }

    return userdetails ? JSON.parse(userdetails) : null;
  }

  coachRegister(payload: any) {
    return this.httpService.post('coach/registration', payload);
  }

  verifyOtp(payload: any) {
    switch (payload.type) {
      case 'forgotpassword':
        return this.httpService.post(
          `${payload.for}/verify-forgot-password`,
          payload
        );
        break;

      default:
        return this.httpService.post(`${payload.for}/verify-otp`, payload);
        break;
    }
  }

  coachResendVerifyOtp(payload: any) {
    return this.httpService.post(`${payload.for}/resend-otp`, payload);
  }

  resetPwdSendOtp(payload: any) {
    return this.httpService.post(`${payload.for}/forgot-password`, payload);
  }

  resetPassword(payload: any) {
    return this.httpService.post(`${payload.for}/update-password`, payload);
  }

  coachChangePassword(payload: any) {
    return this.httpService.post('coach/change-password', payload);
  }

  /**
   * =====================================================
   * End of Coach Authentication Methods
   * =====================================================
   * */

  getToken() {
    if (this.coachLoggedIn()) {
      return this.getCoachToken();
    } else if (this.getSchoolToken()) {
      return this.getSchoolToken();
    } else {
      return null;
    }
  }

  /**
   * ====================================================
   * School Authentication Methods
   *
   * Token Name - calplay-school-token
   * School Details - calplay-school-user
   * ====================================================
   * */
  schoolLogin(payload: any) {
    return this.httpService.post('school/login', payload);
  }

  schoolSuccessLogin(data: any, rememberme: any = false) {
    if (rememberme === true) {
      localStorage.setItem(this.SCHOOLTOKEN_KEY, data.token);
      localStorage.setItem(this.SCHOOLTOKEN_USER, JSON.stringify(data.school));
    } else {
      sessionStorage.setItem(this.SCHOOLTOKEN_KEY, data.token);
      sessionStorage.setItem(
        this.SCHOOLTOKEN_USER,
        JSON.stringify(data.school)
      );
    }
    this.router.navigate(['school/dashboard']);
  }

  schoolLogout() {
    localStorage.removeItem(this.SCHOOLTOKEN_KEY);
    localStorage.removeItem(this.SCHOOLTOKEN_USER);

    sessionStorage.removeItem(this.SCHOOLTOKEN_KEY);
    sessionStorage.removeItem(this.SCHOOLTOKEN_USER);

    this.router.navigate(['/login'], { queryParams: { tab: 'school' } });
  }

  schoolLoggedIn() {
    return !!this.getSchoolToken();
  }

  getSchoolToken() {
    let token = localStorage.getItem(this.SCHOOLTOKEN_KEY);
    if (!token) {
      token = sessionStorage.getItem(this.SCHOOLTOKEN_KEY);
    }

    return token;
  }
  schoolRegister(payload: any) {
    return this.httpService.post('school/registration', payload);
  }

  schoolVerifyOtp(payload: any) {
    switch (payload.type) {
      case 'forgotpassword':
        return this.httpService.post('school/verify-forgot-password', payload);
        break;

      default:
        return this.httpService.post('school/verify-otp', payload);
        break;
    }
  }

  schoolResendVerifyOtp(payload: any) {
    return this.httpService.post('school/resend-otp', payload);
  }

  schoolResetPwdSendOtp(payload: any) {
    return this.httpService.post('school/forgot-password', payload);
  }

  schoolResetPassword(payload: any) {
    return this.httpService.post('school/update-password', payload);
  }

  schoolChangePassword(payload: any) {
    return this.httpService.post('school/change-password', payload);
  }
  getSchoolSessionDetails() {
    let schooldetails = localStorage.getItem(this.SCHOOLTOKEN_USER);
    if (!schooldetails) {
      schooldetails = sessionStorage.getItem(this.SCHOOLTOKEN_USER);
    }

    return schooldetails ? JSON.parse(schooldetails) : null;
  }
}
